import React, { useContext } from "react";

import {
  ExpandLess,
  ExpandMore,
  AssignmentOutlined,
  CreateOutlined,
  CallSplitOutlined,
  AccountBoxOutlined,
  PeopleAlt,
  CancelPresentationOutlined,
  AssessmentOutlined,
  ExitToAppOutlined,
  BusinessOutlined,
  SupervisorAccountOutlined,
} from "@material-ui/icons";

import { UserContext } from "../../context/UserContext";

export const SidebarData = () => {
  const { user } = useContext(UserContext);
  const menu = [];

  const accessRoutes = user.accessRoutes.split(",");

  const checkAccess = (sub) => accessRoutes.includes(sub.path);

  if (accessRoutes.includes("/registers")) {
    const subMenu = [
      {
        title: "Promotores",
        path: "/previewPromoter",
        icon: <BusinessOutlined className="iconSidebar" alt="Promotores" />,
      },
      {
        title: "Usuários",
        path: "/previewUser",
        icon: <AccountBoxOutlined className="iconSidebar" alt="Usuários" />,
      },
      {
        title: "Segmentos",
        path: "/previewSegment",
        icon: <CallSplitOutlined className="iconSidebar" alt="Segmentos" />,
      },
      {
        title: "Motivos Cancel.",
        path: "/previewCancellation",
        icon: (
          <CancelPresentationOutlined
            className="iconSidebar"
            alt="Cancelamento"
          />
        ),
      },
    ].filter(checkAccess);

    menu.push({
      title: "Cadastros",
      icon: <CreateOutlined className="iconSidebar" alt="Cadastros" />,
      iconClosed: <ExpandMore />,
      iconOpened: <ExpandLess />,
      subNav: subMenu,
      context: "Registers",
    });
  }

  if (accessRoutes.includes("/clients")) {
    menu.push({
      title: "Clientes",
      path: "/clients",
      icon: <PeopleAlt className="iconSidebar" alt="Clientes" />,
    });
  }

  if (accessRoutes.includes("/previewContractBond")) {
    menu.push({
      title: "Contratos",
      path: "/previewContractBond",
      icon: <AssignmentOutlined className="iconSidebar" alt="Contratos" />,
    });
  }

  menu.push({
    title: "Sair",
    path: "/login",
    icon: <ExitToAppOutlined className="iconSidebar" alt="Sair" />,
  });

  return menu;
};
